// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/OrderLine.yaml
// Generated: 2026-10-03T15:45:14.045Z
// </auto-generated>

import { ReadOnlyEntityService } from '@/lib/EntityService';
import { OrderLine } from '@/types/sales/OrderLine';

/**
 * OrderLine Service (Read-Only)
 * Query operations for OrderLine via the ABP API.
 */
export const orderLineService = new ReadOnlyEntityService<OrderLine>(
  '/api/sales/orderline',
  'OrderLine',
);
